import _ from 'lodash';

// Sổ nháp điều hướng non-reactive, thay cho goto.studies. KHÔNG phải Zustand store: nhánh này
// trước đây bị `_.assign(gotoRedux.studies, ...)` mutate thẳng vào Redux state mà không dispatch,
// nên không có subscriber và không có re-render. Xem spec §3.
const studyNavigationState: Record<string, any> = {};

// Reset giữ identity của object cấp trên cùng để consumer đang giữ reference không trỏ vào
// object mồ côi.
/**
 * Restores the study navigation state to its defaults so the study screens reopen clean. Deletes every key on the shared studyNavigationState object, then assigns an undefined tab plus a search block defaulting to patientName with no value and no selected study fids.
 *
 * @returns Nothing.
 */
const resetStudyNavigationState = () => {
  _.forEach(_.keys(studyNavigationState), (key) => {
    delete studyNavigationState[key];
  });
  _.assign(studyNavigationState, {
    tab: undefined,
    search: {
      searchValue: undefined,
      searchByValue: 'patientName',
      multiStudyFid: [],
    },
  });
};

resetStudyNavigationState();

export { studyNavigationState, resetStudyNavigationState };
